const emailUtils = {
  getHelpEmail: (isMFSupport = false, isSingleFamilyEnterpriseCustomer = false) => {
    if (isMFSupport) {
      return 'rentalpartners@zillowgroup.com';
    }
    if (isSingleFamilyEnterpriseCustomer) {
      return 'rentalshelp@zillowgroup.com';
    }
    return 'rentalsupport@zillow.com';
  },
};

export default emailUtils;
